import React from 'react';
import { HelpCenterLvl_2_1 } from '../../utils/constant';
import HelpCenterTemplate from '../../components/HelpCenterComponents/HelpCenterTemplate';
import {
  LicensingHeadings,
  PartnershipHeadings,
  PrecticesTroubleshootingHeadings,
} from '../../components/data/data/HelpCenter/HelpCenterData';

const PracticesTroubleshooting = () => {
  return (
    <HelpCenterTemplate
      pageTitle="Practices and Troubleshooting"
      sectionTitle="Understanding Spatial Grid & Business Value"
      sectionDescription="Get started"
      articlesData={PrecticesTroubleshootingHeadings}
      basePath="/help-center/practices-troubleshooting-articles"
      breadcrumbPath={{
        name: 'Practices Troubleshooting',
        path: '/help-center/practices-troubleshooting',
      }}
      searchPlaceholder="Search the Spatial Grid Help Center"
      showArticleCount={true}
      maxDisplayArticles={2}
      seeAllLink="/help-center/practices-troubleshooting-articles"
    />
  );
};

export default PracticesTroubleshooting;
